// Jobs Show Bundle - Optimized bundle for jobs#show page
// This bundle includes only the components needed for individual job pages

import ReactOnRails from "react-on-rails";
import "@rails/actioncable";
import { wrapWithErrorBoundary } from "@/shared/components/error";

// Components used in jobs#show page - Now using organized components:

// Job Description component (used in both practice_show and professional_show)
import { JobDescription, Job } from '@/domains/jobs';

// Rating component for temp jobs (used in both practice_show and professional_show)
import { JobPageRating } from '@/domains/ratings';

// Quick Apply component (used in professional_show for job applications)
import { QuickApply } from '@/domains/applications';

// Profile List component (used in practice_show for candidates and in _candidates.html.erb)
import { ProfileList } from '@/domains/profiles';

// Practice Favorite Button (used in _practice_info.html.erb)
import { PracticeFavoriteButton } from '@/domains/favorites';

// Send Message Button (used in _practice_info.html.erb)
import { SendMessageButton } from '@/domains/messaging';

// Supporting components needed for job pages
import { SBChat, SBMobileBanner, SBSendMessage } from '@/domains/messaging';

// AI Assistant (used in layouts/application.html.erb for practice users)

// Job Closing Survey component (used in practice_show for closing jobs)
// ManageApplicants component (used in practice_show for applicants sub-tab)
import { JobClosingSurveyIntegration, ManageApplicants } from '@/domains/management';
import { globalComponents } from '@/shared/registerGlobalComponents';

// Register only the components needed for jobs#show
ReactOnRails.register(wrapWithErrorBoundary({
  ...globalComponents,
    JobDescription,
    JobPageRating,
    QuickApply,
    ProfileList,
    PracticeFavoriteButton,
    SendMessageButton,
    SBChat,
    SBMobileBanner,
    SBSendMessage,
    Job,
    JobClosingSurveyIntegration,
    ManageApplicants,
}));

// Jobs show page specific optimizations
document.addEventListener('DOMContentLoaded', function () {
    // Job application tracking for analytics
    const applyButtons = document.querySelectorAll('a[href*="/apply"], .quick-apply-button');
    applyButtons.forEach(button => {
        button.addEventListener('click', function () {
            // Track job application clicks
            if (typeof gtag !== 'undefined') {
                gtag('event', 'job_application_click', {
                    'event_category': 'Jobs',
                    'event_label': 'Apply Button Click',
                    'job_id': this.dataset.jobId || 'unknown'
                });
            }
        });
    });

    // Practice favorite button tracking
    const favoriteButtons = document.querySelectorAll('[data-react-component="PracticeFavoriteButton"]');
    favoriteButtons.forEach(button => {
        button.addEventListener('click', function () {
            if (typeof gtag !== 'undefined') {
                gtag('event', 'practice_favorite', {
                    'event_category': 'Jobs',
                    'event_label': 'Practice Favorite Toggle'
                });
            }
        });
    });

    // Rating component tracking
    const ratingComponents = document.querySelectorAll('[data-react-component="JobPageRating"]');
    ratingComponents.forEach(component => {
        // Add mutation observer to track when ratings are submitted
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    const ratingSubmitted = Array.from(mutation.addedNodes).some(node =>
                        node.textContent && node.textContent.includes('Rating submitted')
                    );
                    if (ratingSubmitted && typeof gtag !== 'undefined') {
                        gtag('event', 'rating_submitted', {
                            'event_category': 'Jobs',
                            'event_label': 'Temp Job Rating'
                        });
                    }
                }
            });
        });
        observer.observe(component, { childList: true, subtree: true });
    });

    // Message button tracking
    const messageButtons = document.querySelectorAll('[data-react-component="SendMessageButton"]');
    messageButtons.forEach(button => {
        button.addEventListener('click', function () {
            if (typeof gtag !== 'undefined') {
                gtag('event', 'send_message', {
                    'event_category': 'Jobs',
                    'event_label': 'Contact Practice'
                });
            }
        });
    });

    // Profile list interactions
    const profileLists = document.querySelectorAll('[data-react-component="ProfileList"]');
    profileLists.forEach(list => {
        list.addEventListener('click', function (event) {
            if (event.target.closest('.profile-card, .candidate-card')) {
                if (typeof gtag !== 'undefined') {
                    gtag('event', 'candidate_profile_view', {
                        'event_category': 'Jobs',
                        'event_label': 'View Candidate Profile'
                    });
                }
            }
        });
    });

    // Job description readability improvements
    const jobDescriptions = document.querySelectorAll('[data-react-component="JobDescription"]');
    jobDescriptions.forEach(description => {
        // Add reading time estimation
        const textContent = description.textContent || '';
        const wordCount = textContent.split(/\s+/).length;
        const readingTime = Math.ceil(wordCount / 200); // Average 200 words per minute

        if (readingTime > 1) {
            const readingTimeElement = document.createElement('small');
            readingTimeElement.className = 'text-muted reading-time';
            readingTimeElement.textContent = `📖 ${readingTime} min read`;
            readingTimeElement.style.cssText = 'display: block; margin-bottom: 10px; font-style: italic;';

            const parentElement = description.closest('.job-description, .content-description');
            if (parentElement) {
                parentElement.insertBefore(readingTimeElement, description);
            }
        }
    });

    // Accessibility improvements for job show page
    const focusableElements = document.querySelectorAll('button, a, input, select, textarea, [tabindex]');
    focusableElements.forEach(element => {
        element.addEventListener('focus', function () {
            this.style.outline = '2px solid #0f4b89';
            this.style.outlineOffset = '2px';
        });

        element.addEventListener('blur', function () {
            this.style.outline = '';
            this.style.outlineOffset = '';
        });
    });

    console.log('Jobs show bundle loaded successfully');
});
